import { IconProps } from '.';

export default function ArrowDown({ color = '#fff' }: IconProps) {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.51812 1.45132C4.90302 0.784657 5.86527 0.784658 6.25017 1.45132L9.75645 7.52437C10.1413 8.19104 9.66022 9.02437 8.89042 9.02437L1.87787 9.02437C1.10807 9.02437 0.626946 8.19104 1.01185 7.52437L4.51812 1.45132Z"
        fill={color}
      />
    </svg>
  );
}
